var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReloadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/outline/rotate-right"
  }, /*#__PURE__*/React.createElement("g", {
    id: "rotate-right"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.9999 18.9583C5.66657 18.9583 2.1499 15.4333 2.1499 11.1083C2.1499 6.78333 5.66657 3.25 9.9999 3.25C10.8916 3.25 11.7582 3.375 12.5916 3.63333C12.9249 3.73333 13.1082 4.08333 13.0082 4.41667C12.9082 4.75 12.5582 4.93333 12.2249 4.83333C11.5166 4.61667 10.7666 4.5 9.9999 4.5C6.35824 4.5 3.3999 7.45833 3.3999 11.1C3.3999 14.7417 6.35824 17.7 9.9999 17.7C13.6416 17.7 16.5999 14.7417 16.5999 11.1C16.5999 9.78333 16.2166 8.51667 15.4916 7.43333C15.2999 7.15 15.3749 6.75833 15.6666 6.56667C15.9499 6.375 16.3416 6.45 16.5332 6.74167C17.3999 8.03333 17.8582 9.54167 17.8582 11.1083C17.8499 15.4333 14.3332 18.9583 9.9999 18.9583Z",
    fill: "#56585E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M13.4415 5.05916C13.2665 5.05916 13.0915 4.98416 12.9665 4.84249L10.5582 2.07582C10.3332 1.81749 10.3582 1.41749 10.6165 1.19249C10.8749 0.967491 11.2749 0.992492 11.4999 1.25082L13.9082 4.01749C14.1332 4.27583 14.1082 4.67582 13.8499 4.90083C13.7415 5.00916 13.5915 5.05916 13.4415 5.05916Z",
    fill: "#56585E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M10.6333 7.10834C10.4417 7.10834 10.25 7.01667 10.125 6.85C9.92501 6.575 9.98335 6.18334 10.2583 5.975L13.0667 3.925C13.3417 3.71667 13.7333 3.78334 13.9417 4.05834C14.15 4.33334 14.0833 4.725 13.8083 4.93334L11 6.99167C10.8917 7.075 10.7667 7.10834 10.6333 7.10834Z",
    fill: "#56585E"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReloadIcon);
export default __webpack_public_path__ + "static/media/reload-icon.f603568a56e0f2d116ffe432cd3e2fe4.svg";
export { ForwardRef as ReactComponent };